import { useState, useRef } from "react";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { useTranslation } from "next-i18next";
import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";

const AdvertisingServices = ({ AdServices }) => {
  const { t } = useTranslation("home");
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="w-full box-border text-text-primary px-[24px] md:px-[60px] lg:px-[80px] xl:px-[80px] pb-[40px] md:pb-[40px] lg:pb-[60px] xl:pb-[60px] max-w-[1600px] mx-auto">
      <div className="mx-auto flex flex-col gap-6 md:gap-10">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
          <h2 className="font-medium text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] m-0">
            {t("home.advertisingService.title")}
          </h2>
        </div>

        <div className="flex flex-col gap-4">
          {AdServices?.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className="w-full border-gray-500 border-solid border-b-[1px] box-border"
              >
                <button
                  onClick={() => toggleIndex(index)}
                  aria-expanded={isOpen}
                  aria-controls={`ad-service-content-${index}`}
                  className="w-full p-0 pb-4 flex justify-between items-center text-start text-black bg-transparent cursor-pointer"
                >
                  <h3 className="font-medium text-[20px] leading-[140%] m-0">
                    {item?.title}
                  </h3>
                  {isOpen ? (
                    <AiOutlineMinus className="w-6 h-6 text-black" />
                  ) : (
                    <AiOutlinePlus className="w-6 h-6 text-black" />
                  )}
                </button>

                <div
                  id={`ad-service-content-${index}`}
                  className="grid transition-[grid-template-rows] duration-300 ease-in-out"
                  style={{
                    gridTemplateRows: isOpen ? "1fr" : "0fr",
                  }}
                >
                  <div className="overflow-hidden">
                    <div className="pb-4">
                      {/* h-[27vh] overflow-y-auto */}
                      <div
                        className="font-normal text-[16px] leading-[150%] text-black rich-text p-2.5 bg-[#f1f1f1]"
                        dangerouslySetInnerHTML={{
                          __html: addDofollowToAnchors(item?.description) || "",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AdvertisingServices;

// import { useTranslation } from "next-i18next";
// import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";
// import {
//   FaSearch,
//   FaAd,
//   FaHashtag,
//   FaPencilRuler,
//   FaCode,
//   FaFingerprint,
//   FaPalette,
//   FaVideo,
//   FaMobileAlt,
//   FaNewspaper,
//   FaCalendarAlt,
//   FaShoppingCart,
//   FaStar,
//   FaBullseye,
// } from "react-icons/fa";

// // One icon per service, keyed by the service's `slug`.
// const SERVICE_ICONS = {
//   "digital-marketing-agency": FaStar,
//   "seo-company-dubai": FaSearch,
//   "paid-media-agency": FaAd,
//   "social-media-marketing-agency-in-dubai": FaHashtag,
//   "web-design-agency": FaCode,
//   "branding-agency-dubai": FaFingerprint,
//   "advertising-agency": FaPalette,
//   "content-marketing-agency": FaPencilRuler,
//   "video-production-company-dubai": FaVideo,
//   "mobile-app-development-company-in-dubai": FaMobileAlt,
//   "pr-agency-dubai": FaNewspaper,
//   "events-management": FaCalendarAlt,
//   "e-commerce-marketing-agency": FaShoppingCart,
// };

// // Used if a slug doesn't match anything above.
// const FALLBACK_ICON = FaBullseye;

// const AdvertisingServices = ({ AdServices }) => {
//   const { t } = useTranslation("home");

//   return (
//     <section className="w-full box-border text-text-primary px-[24px] md:px-[60px] lg:px-[80px] xl:px-[80px] py-[40px] md:py-[40px] lg:py-[60px] xl:py-[60px] max-w-[1600px] mx-auto">
//       <div className="mx-auto flex flex-col gap-6 md:gap-10">
//         {/* Header */}
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
//           <h2 className="font-medium text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] m-0 text-black">
//             {t("home.advertisingService.title")}
//           </h2>
//         </div>

//         {/* Card grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {AdServices?.map((item, index) => {
//             const Icon = SERVICE_ICONS[item?.slug] || FALLBACK_ICON;

//             return (
//               <div
//                 key={item?.slug || index}
//                 className="flex flex-col gap-5 p-6 md:p-7 rounded-2xl bg-white border border-solid border-gray-400 shadow-sm hover:shadow-md transition-shadow duration-300"
//               >
//                 {/* Icon chip */}
//                 <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-crimson">
//                   <Icon className="w-5 h-5 text-white" />
//                 </div>

//                 {/* Title */}
//                 <h3 className="font-semibold text-[20px] md:text-[22px] leading-[130%] m-0 text-black">
//                   {item?.title}
//                 </h3>

//                 {/* Description */}
//                 <div
//                   className="font-normal text-[16px] leading-[160%] text-black rich-text"
//                   dangerouslySetInnerHTML={{
//                     __html: addDofollowToAnchors(item?.description) || "",
//                   }}
//                 />
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AdvertisingServices;
